import { useEffect, useState } from 'react';

export const ClockTimer = ({ threshold = 40, isRunning, resetKey, hasSelectedOption }: any) => {
    const [seconds, setSeconds] = useState(0);

    useEffect(() => {
        setSeconds(0);
    }, [resetKey]);

    useEffect(() => {
        let interval: any;
        if (isRunning && !hasSelectedOption) {
            interval = setInterval(() => {
                setSeconds((s: number) => s + 1);
            }, 1000);
        }
        return () => clearInterval(interval);
    }, [isRunning, hasSelectedOption, resetKey]);

    if (hasSelectedOption) {
        return null;
    }

    let color = '#4CAF50'; 
    if (seconds >= threshold-10 && seconds <= threshold) {
        color = '#FFC107'; 
    } else if (seconds > threshold) {
        color = '#F44336'; 
    }

    return (
        <span style={{ marginLeft: '10px', display: 'inline-flex', alignItems: 'center' }}>
            <div className={`clock-timer-container${(isRunning && color==='#FFC107') ? ' clock-timer-pulse' : ''}`} style={{ padding: '0px', '--pulse-color': color } as React.CSSProperties}>
                <svg height="100%" width="100%" xmlns="http://www.w3.org/2000/svg" style={{ position: 'absolute', top: 0, left: 0, overflow: 'visible' }}>
                    <circle
                        cx="50%"
                        cy="50%"
                        r="calc(50% - 1px)"
                        className={isRunning ? 'clock-animated-line' : ''}
                        stroke={color}
                        strokeWidth="2"
                        fill="transparent"
                    />
                </svg>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" style={{ position: 'relative', zIndex: 1 }}>
                    <circle cx="12" cy="12" r="10" />
                    <polyline points="12 6 12 12 16 14" />
                </svg>
            </div>
        </span>
    );
};
